import React, { useEffect, useState } from "react";
import "./sidebar.css";
import { Link, NavLink } from "react-router-dom";
import {
  BoxArrowInLeft,
  ChevronBarRight,
  ChevronBarUp,
  Coin,
  Gear,
  Geo,
  HeadsetVr,
  House,
  List,
  People,
} from "react-bootstrap-icons";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";

const Sidebar = ({ sideNavExpanded, setSideNavExpanded }) => {
  const [isOpen, setIsOpen] = useState(false);
  const role = useSelector((state) => state.auth.role.roleName);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleToggle = () => {
    setIsOpen(!isOpen);
    setSideNavExpanded(!sideNavExpanded);
  };

  const theme = useTheme();

  const handleNavigate = () => {
    if (isMobile) {
      handleToggle();
    }
  };
  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="logo-details">
        {isOpen ? (
          <div className="menu">
            {isMobile ? (
              <ChevronBarUp
                onClick={handleToggle}
                fill={theme.palette.primary[600]}
              />
            ) : (
              <ChevronBarRight
                onClick={handleToggle}
                fill={theme.palette.primary[600]}
              />
            )}
          </div>
        ) : (
          <div className="menu">
            <List onClick={handleToggle} />
          </div>
        )}
        <img
          src={"/assets/lavr-logo.png"}
          alt="lavr-logo"
          className="smallLogo"
        />
      </div>
      <ul className="nav-list">
        {role === "SuperAdmin" ? (
          <li>
            <NavLink to="/app" onClick={handleNavigate} end>
              <House size={24} />
              <span className="links_name">الرئيسية</span>
            </NavLink>
            <span className="tooltip">الرئيسية</span>
          </li>
        ) : (
          ""
        )}
        <li>
          <NavLink to="/app/views" onClick={handleNavigate}>
            <HeadsetVr size={24} />
            <span className="links_name">المشاهدات</span>
          </NavLink>
          <span className="tooltip">بيانات المشاهدات</span>
        </li>
        {role === "Admin" || role === "SuperAdmin" ? (
          <li>
            <NavLink to="/app/users" onClick={handleNavigate}>
              <People size={24} />
              <span className="links_name">المستخدمين</span>
            </NavLink>
            <span className="tooltip">المستخدمين</span>
          </li>
        ) : (
          ""
        )}
        {role === "Admin" || role === "SuperAdmin" ? (
          <li>
            <NavLink to="/app/sites" onClick={handleNavigate}>
              <Geo size={24} />
              <span className="links_name">المواقع</span>
            </NavLink>
            <span className="tooltip">المواقع</span>
          </li>
        ) : (
          ""
        )}
        {role === "SuperAdmin" ? (
          <li>
            <NavLink to="/app/beneficiaries" onClick={handleNavigate}>
              <Coin size={24} />
              <span className="links_name">المستفيدون </span>
            </NavLink>
            <span className="tooltip">المستفيدون </span>
          </li>
        ) : (
          ""
        )}
        {role === "SuperAdmin" ? (
          <li>
            <NavLink to="/app/settings" onClick={handleNavigate}>
              <Gear size={24} />
              <span className="links_name">الإعدادات</span>
            </NavLink>
            <span className="tooltip">الإعدادات</span>
          </li>
        ) : (
          ""
        )}

        <li className="logout">
          <Link to="/logout" onClick={handleNavigate}>
            <BoxArrowInLeft size={24} />
            <span className="links_name">تسجيل الخروج</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
